import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  getAllPages,
  createMenu,
  getMenu,
  deleteMenu,
  publishMenu,
  editMenu,
  requestPublish,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { NecStore } from "../../store/necStore";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { UserLang, UserStore } from "../../store/userStore";
import { Link } from "react-router-dom";
import ToolTip from "../tooltip/tooltip";

const Menus = (props) => {
  /*   const [modalShow, setModalShow] = useState(false);
  const [allImage,setallImage] = useState([]);
  const [pageModalShow, setPageModalShow] = useState(false);
  */

  const menu = [
    {
      menuTitle: "",
      urlName: "",
      menuType: "",
      menuPage: {},
      menuIcon: "",
      menuOrder: "",
      items: [],
    },
  ];

  const menuPic = [
    {
      value: "Home",
      label: "Home",
    },
    {
      value: "Music",
      label: "Music",
    },
    {
      value: "Star",
      label: "Star",
    },
    {
      value: "Document",
      label: "Document",
    },
    {
      value: "Padlock",
      label: "Padlock",
    },
    {
      value: "Dollar",
      label: "Dollar",
    },
    {
      value: "Crown",
      label: "Crown",
    },
    {
      value: "Audio",
      label: "Audio",
    },
    {
      value: "Profile",
      label: "Profile",
    },
    {
      value: "Bar Menu",
      label: "Bar Menu",
    },
    {
      value: "Dot Menu",
      label: "Dot Menu",
    },
    {
      value: "Bell",
      label: "Bell",
    },
    {
      value: "Video",
      label: "Video",
    },
    {
      value: "Sort",
      label: "Sort",
    },
    {
      value: "Photo",
      label: "Photo",
    },
    {
      value: "Eye",
      label: "Eye",
    },
    {
      value: "Search",
      label: "Search",
    },
    {
      value: "Movie",
      label: "Movie",
    },
    {
      value: "Setting",
      label: "Setting",
    },
    {
      value: "Globe",
      label: "Globe",
    },
    {
      value: "Folder",
      label: "Folder",
    },
    {
      value: "Paint",
      label: "Paint",
    },

    {
      value: "Cast",
      label: "Cast",
    },
    {
      value: "Refresh",
      label: "Refresh",
    },
    {
      value: "Play",
      label: "Play",
    },
    {
      value: "Stop",
      label: "Stop",
    },
    {
      value: "Pause",
      label: "Pause",
    },
    {
      value: "Trash",
      label: "Trash",
    },
    {
      value: "Close",
      label: "Close",
    },
    {
      value: "Back Arrow",
      label: "Back Arrow",
    },
    {
      value: "Forward Arrow",
      label: "Forward Arrow",
    },
    {
      value: "Down Arrow",
      label: "Down Arrow",
    },
    {
      value: "Up Arrow",
      label: "Up Arrow",
    },
    {
      value: "Live",
      label: "Live",
    },
  ];

  const [final, setFinal] = useState([]);
  const [allPage, setallPage] = useState([]);
  const [newMenu, setnewMenu] = useState([menu]);
  const [menuName, setMenuName] = useState("");
  const [loading, setLoading] = useState(false);
  const role = NecStore.useState((s) => s.setting);
  const lan = UserLang.useState((s) => s.lan);
  const user = UserStore.useState((s) => s.user);
  const [store, setStore] = useState([]);
  const [draged, setDraged] = useState([]);
  const [allIcon, setIcon] = useState(menuPic);
  const [characters, updateCharacters] = useState([]);

  useEffect(() => {
    const getPaged = async () => {
      try {
        const appl = await getAllPages(200, 0);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
          urlName: item.urlName,
          pageType: item.pageType,
        }));
        setallPage(opt);
      } catch (error) {}
    };

    const getMenus = async () => {
      setLoading(true);
      try {
        const appl = await getMenu();

        const newArray = appl.data;
        if (appl.data.length !== 0) {
          const opt = newArray.map((item) => ({
            menuTitle: item.menuTitle,
            urlName: item.urlName,
            menuType: item.menuType,
            menuPage: item.menuPage ? item.menuPage._id : "",
            menuPageName: item.menuPage ? item.menuPage.referenceName : "",
            menuOrder: item.menuOrder,
            menuIcon: item.menuIcon,
            items: item.items,
            _id: item._id,
          }));
          if (opt) {
            const a = [...opt].sort((a, b) => a.menuOrder - b.menuOrder);

            setDraged(opt);
            setFinal(opt);
            updateCharacters(a);
          }
        }
        setLoading(false);
      } catch (error) {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    };
    getPaged();
    getMenus();
  }, [store]);

  const setNotifications = async (editing) => {
    setLoading(true);
    /* eslint-disable no-unused-vars */
    const pageid = props.match.params.id;
    const result = await requestPublish(editing).then(
      (result) => {
        toastr.success("Request Sent", "Success");

        // brandImage(result.data);
        // setPage(result.data);
        setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: null,
      itemid: null,
      redirect: "menu",
      message: "Content Editor requested to Publish Menu",
    };

    setNotifications(opt);
  };

  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.menuOrder = index + 1;
      return item;
    });
    updateCharacters(newItems);

    // for(var i=0; i<items.length;i++)
    // {
    // setDraged(newItems);
    dragSave();
    // }
  };

  const dragSave = async () => {
    // setLoading(true);
    for (var i = 0; i < characters.length; i++) {
      /* eslint-disable no-unused-vars */
      const result = await editMenu(characters[i], characters[i]._id).then(
        (result) => {},
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          // setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    }
    // window.location.reload(false);
    setLoading(false);
  };

  //   const dragItem= (items)=>
  //   {

  //     const newItems =   items.map((item,index) => {

  //       item.menuOrder = index+1;
  //       return item;

  //    });
  //   //  updateCharacters(newItems);
  //
  //    // for(var i=0; i<items.length;i++)
  //    // {
  //      setDraged(newItems);
  //     //  for(var i=0; i<characters.length;i++)
  //     //  dragDelete(characters[i]._id);
  //    dragSave();
  //    updateCharacters(newItems);

  //   //  setLoading(false);
  //  // }
  //   }

  // const dragDelete = async(id)=>{
  //   if(id!==undefined && id!=="")
  //   {
  //     try{
  //       /* eslint-disable no-unused-vars */
  //       const result = await deleteMenu(id);
  //       /* eslint-disable no-unused-vars */
  //       // toastr.success("Successfully Deleted", 'Success');

  //     }
  //     catch(error)
  //     {
  //
  //       // toastr.error("Error in deleting the Menu", 'Error');
  //     }
  //   }
  //   // else
  //   // {
  //   //   toastr.error("Delete Id is Missing", 'Error');
  //   // }
  //  }

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    setLoading(true);
    reorderArray(items);

    // dragItem(items);
  };

  const onChangeItem = (value, evt) => {
    const newest = newMenu;
    newest["menuPage"] = value.value;
    newest["urlName"] = value.urlName;
    newest["menuType"] = value.pageType;
    setMenuName(value.label);
    setnewMenu(newest);

    setIcon(menuPic);
  };
  const onChangeItemed = (value, evt) => {
    setnewMenu({
      ...newMenu,
      [evt.name]: value.value,
    });
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setnewMenu({
      ...newMenu,
      [evt.target.name]: value,
    });
  };
  const handleChanged = (evt) => {
    const value = evt.target.value;
    setnewMenu({
      ...newMenu,
      [evt.target.name]: value,
    });
  };
  const handleSave = async (evt) => {
    evt.preventDefault();
    setLoading(true);

    const opt = {
      menuPage: newMenu.menuPage,
      menuPageName: newMenu.menuPageName,
      menuPageType: newMenu.menuPageType,
      urlName: newMenu.urlName,
      menuTitle: newMenu.menuTitle,
      menuOrder: characters.length + 1,
      menuType: newMenu.menuType,
      items: newMenu.items,
      menuIcon: newMenu.menuIcon,
    };

    let a = opt;
    /* eslint-disable no-unused-vars */

    const result = await createMenu(a).then(
      (result) => {
        toastr.success("Successfully Saved", "Success");
        const obj = {
          menuTitle: result.data.menuTitle,
          urlName: result.data.urlName,
          menuType: result.data.menuType,
          menuPage: result.data.menuPage,
          _id: result.data._id,
          menuPageName: menuName,
          menuIcon: result.data.menuIcon,
          menuOrder: result.data.menuOrder,
          items: result.data.items,
        };
        setFinal([...final, obj]);
        updateCharacters([...characters, obj]);
        setDraged([...draged, obj]);
        setLoading(false);
        setnewMenu([menu]);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const publish = async (evt) => {
    evt.preventDefault();
    setLoading(true);
    /* eslint-disable no-unused-vars */
    //
    const result = await publishMenu().then(
      (result) => {
        toastr.success("Successfully Saved", "Success");
        setStore(result);
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };
  const handleDelete = async (event, index, id) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(removeId, 1);
    setFinal(items);
    reorderArray(items);
    if (id !== undefined && id !== "") {
      try {
        /* eslint-disable no-unused-vars */
        const result = await deleteMenu(id);
        /* eslint-disable no-unused-vars */
        toastr.success("Successfully Deleted", "Success");
      } catch (error) {
        toastr.error("Error in deleting the Menu", "Error");
      }
    } else {
      toastr.error("Delete Id is Missing", "Error");
    }
  };

  const updateVisiblity = (event) => {
    setnewMenu({
      ...newMenu,
      [event.target.name]: event.target.checked ? "multiple" : "Normal",
    });
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Add Menu
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              className="form-group"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select required pages available on the menu"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Menu Page *&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select required pages available on the menu"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="menuPage"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allPage}
                                onChange={(value, event) =>
                                  onChangeItem(value, event)
                                }
                              ></Select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={"Display name for the menu"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Menu Name *&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={"Display name for the menu"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <input
                                type="text"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                                name="menuTitle"
                                className="form-control inside-form"
                                placeholder="Name..."
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-3">
           <div className="form-group">
                  <label>Menu Order</label>
                  <input type="number" name="menuOrder" className="form-control inside-form" placeholder="Menu Order..."  onChange={handleChanged}   autoComplete="off" />
                </div>
             
           </div> */}

                          <div className="col-md-4">
                            <div
                              className="form-group"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Menu icon displayed on mobile devices"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Menu Icon&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Menu icon displayed on mobile devices"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="menuIcon"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allIcon}
                                onChange={(value, event) =>
                                  onChangeItemed(value, event)
                                }
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-9"></div>
                          <div className="col-md-3">
                            <div
                              className="form-group"
                              style={{ padding: "0" }}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={"Enable this to create multiple menu"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Menu Type&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={"Enable this to create multiple menu"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                            </div>
                            <div className="form-group ">
                              <div
                                className="custom-control custom-switch"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                                style={{ paddingTop: "30px" }}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name={"menuType"}
                                  id={"menuType"}
                                  dir={lan === "rtl" ? "rtl" : "ltr"}
                                  onClick={(event) => updateVisiblity(event)}
                                />
                                <label
                                  className={
                                    lan === "rtl"
                                      ? "custom-control-label not-bold float-right"
                                      : "float-left custom-control-label not-bold"
                                  }
                                  htmlFor={"menuType"}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Multiple
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-12">
                            <div
                              className={
                                lan === "rtl"
                                  ? "float-left btn-group btn-group-md"
                                  : "float-right btn-group btn-group-md"
                              }
                              role="group"
                            >
                              <button
                                type="button"
                                className="btn btn-primary"
                                style={{
                                  width: "100px",
                                  marginRight: "6px",
                                  float: "right",
                                }}
                                onClick={handleSave}
                                disabled={
                                  newMenu.menuTitle
                                    ? newMenu.menuIcon
                                      ? newMenu.menuPage
                                        ? false
                                        : newMenu.menuType !== "multiple"
                                          ? true
                                          : false
                                      : true
                                    : true
                                }
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            {characters ? (
                              <DragDropContext onDragEnd={handleOnDragEnd}>
                                <Droppable droppableId={"characters"}>
                                  {(provided) => (
                                    <table
                                      dir={lan === "rtl" ? "rtl" : "ltr"}
                                      id="appadmin"
                                      ref={provided.innerRef}
                                      {...provided.droppableProps}
                                      className="table table-bordered table-hover dataTable dtr-inline"
                                      role="grid"
                                      aria-describedby="example2_info"
                                    >
                                      <thead>
                                        <tr role="row">
                                          <th
                                            className="sorting_asc"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            {" "}
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Menu Name
                                            </label>
                                          </th>
                                          <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Menu page
                                            </label>
                                          </th>
                                          <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Url Name
                                            </label>
                                          </th>
                                          <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Menu Order
                                            </label>
                                          </th>
                                          <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Menu Icon
                                            </label>
                                          </th>
                                          <th
                                            className="sorting"
                                            tabIndex={0}
                                            aria-controls="example2"
                                            rowSpan={1}
                                            colSpan={1}
                                          >
                                            <label
                                              className={
                                                lan === "rtl"
                                                  ? "float-right"
                                                  : "float-left"
                                              }
                                            >
                                              Delete
                                            </label>
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {characters.map((person, index) => (
                                          <Draggable
                                            key={
                                              person.menuPage + person.menuOrder
                                            }
                                            draggableId={
                                              "item" + person.menuOrder
                                            }
                                            index={index}
                                          >
                                            {(provided) => (
                                              <tr
                                                role="row"
                                                className="even"
                                                key={index}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                <td
                                                  className="dtr-control sorting_1"
                                                  tabIndex={0}
                                                >
                                                  <label
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right broad"
                                                        : "float-left broad"
                                                    }
                                                  >
                                                    {person.menuType !==
                                                    "multiple" ? (
                                                      person.menuTitle
                                                    ) : (
                                                      <Link
                                                        to={{
                                                          pathname:
                                                            "/menu/" +
                                                            person._id,
                                                          state: {
                                                            dir:
                                                              lan === "rtl"
                                                                ? "rtl"
                                                                : "ltr",
                                                          },
                                                        }}
                                                      >
                                                        {person.menuTitle}
                                                      </Link>
                                                    )}
                                                  </label>
                                                </td>
                                                <td>
                                                  <label
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right broad"
                                                        : "float-left broad"
                                                    }
                                                  >
                                                    {person.menuPageName}
                                                  </label>
                                                </td>
                                                <td>
                                                  <label
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right broad"
                                                        : "float-left broad"
                                                    }
                                                  >
                                                    {person.urlName}
                                                  </label>
                                                </td>
                                                <td>
                                                  <label
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right broad"
                                                        : "float-left broad"
                                                    }
                                                  >
                                                    {person.menuOrder}
                                                  </label>
                                                </td>
                                                <td>
                                                  <label
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right broad"
                                                        : "float-left broad"
                                                    }
                                                  >
                                                    {person.menuIcon}
                                                  </label>
                                                </td>
                                                <td>
                                                  <button
                                                    type="button"
                                                    className={
                                                      lan === "rtl"
                                                        ? "float-right btn btn-light"
                                                        : "float-left btn btn-light"
                                                    }
                                                    onClick={(event) =>
                                                      handleDelete(
                                                        event,
                                                        index,
                                                        person._id
                                                      )
                                                    }
                                                  >
                                                    <i className="fa fa-trash"></i>{" "}
                                                    Delete
                                                  </button>
                                                </td>
                                              </tr>
                                            )}
                                          </Draggable>
                                        ))}

                                        {provided.placeholder}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td colSpan={6}>
                                            {" "}
                                            <div className="row">
                                              <div className="col-md-12">
                                                <div
                                                  className={
                                                    lan === "rtl"
                                                      ? "float-left btn-group btn-group-md"
                                                      : "float-right btn-group btn-group-md"
                                                  }
                                                  role="group"
                                                >
                                                  {role.RFP === true &&
                                                  user.editor === true ? (
                                                    <button
                                                      type="#!"
                                                      onClick={
                                                        handlePublishRequest
                                                      }
                                                      className="btn btn-success"
                                                      style={{
                                                        width: "200px",
                                                        marginRight: "6px",
                                                      }}
                                                      disabled={
                                                        !role.production ===
                                                        true
                                                          ? true
                                                          : false
                                                      }
                                                      hidden={
                                                        !role.production ===
                                                        true
                                                          ? true
                                                          : false
                                                      }
                                                    >
                                                      Request to Publish
                                                    </button>
                                                  ) : (
                                                    <button
                                                      type="#!"
                                                      onClick={publish}
                                                      className="btn btn-success"
                                                      style={{
                                                        width: "100px",
                                                        marginRight: "6px",
                                                      }}
                                                      disabled={
                                                        !role.production ===
                                                        true
                                                          ? true
                                                          : false
                                                      }
                                                      hidden={
                                                        !role.production ===
                                                        true
                                                          ? true
                                                          : false
                                                      }
                                                    >
                                                      Publish
                                                    </button>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Menus;
